export const getTestId = (section: string, customId: string) => `${section}-${customId}`;
